"use client";
import React, { useState } from 'react';
import Image from 'next/image';
import { Spinner } from '@/components/ui/shadcn-io/spinner';

interface HeroImageProps {
  src: string;
  alt: string;
  className?: string;
  sizes?: string;
  priority?: boolean;
  blurDataURL?: string; // optional explicit blur placeholder
}

// Tiny very-light green blur placeholder (1KB-ish SVG encoded)
const DEFAULT_BLUR =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjgwMCI+PHJhZCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiByeD0iMzIiIGZpbGw9IiNlNmY0ZWEiIC8+PC9zdmc+';

export default function HeroImageShared({ src, alt, className, sizes, priority, blurDataURL }: HeroImageProps) {
  const [loaded, setLoaded] = useState(false);
  const blur = blurDataURL || DEFAULT_BLUR;

  return (
    <div className={`relative w-full h-full ${className || ''}`}>
      {!loaded && (
        <div className="absolute inset-0 rounded-2xl flex items-center justify-center bg-white/5">
          <Spinner size={40} className="text-green-600" />
        </div>
      )}
      <Image
        src={src}
        alt={alt}
        fill
        priority={priority}
        fetchPriority={priority ? 'high' : 'auto'}
        sizes={sizes}
        placeholder="blur"
        blurDataURL={blur}
        className={`object-cover rounded-2xl transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
